import React from 'react';
import styled from 'styled-components';

import Header from 'core/ui/components/Header/Header';
import { NavItem , MobileNavItem } from 'core/ui/atoms/V2';
import InviteFriends from 'dashboard/ui/components/InviteFriends';
import LogoutButton from 'core/ui/components/LogoutButton';
import { EXTERNAL_LINKS } from 'core/api/constants';

function DashboardHeader() {
  const rightNavItems = () => {
    return [
      <NavItem to="/" exact activeClassName="active" key="nav-home">Home</NavItem>,
      <NavItem to="/orders" exact activeClassName="active" key="nav-orders">Orders</NavItem>,
      <NavItem to="/settings" activeClassName="active" key="nav-settings">Settings</NavItem>,
      <InviteFriends id='header-invite-friends' key="nav-refer" btn-primary />,
      <LogoutButton btn-unstyled key="nav-sign-out" reload={true}>Log out</LogoutButton>,
    ];
  };

  const mobileNavItems = () => {
    return [
      <MobileNavItem to="/" exact activeClassName="active" key="nav-home">Home</MobileNavItem>,
      <MobileNavItem key="nav-programs"
        subMenus={[
          { label: 'Signature Program', href: EXTERNAL_LINKS.signatureProgram },
        ]}>
        Our Programs
      </MobileNavItem>,
      <MobileNavItem to="/orders" exact activeClassName="active" key="nav-orders">Orders</MobileNavItem>,
      <MobileNavItem to="/settings" activeClassName="active" key="nav-settings">Settings</MobileNavItem>,
      <MobileInviteFriends btn-unstyled key="nav-refer" />,
      <LogoutButton btn-unstyled key="nav-sign-out" reload={true}>Log out</LogoutButton>,
    ].filter((i) => i);
  };

  return (
    <Header rightNavItems={rightNavItems} mobileNavItems={mobileNavItems} />
  );
}

const MobileInviteFriends = styled(InviteFriends)`
  white-space: nowrap;
`;

export default DashboardHeader;
